module.exports = __webpack_public_path__ + "media/images/plans/wedding_compact/hall-list/plan-wedding-lineup-kanto-4-3f409669208de31f2c304b46a27fae9f.png";